module.exports = __webpack_public_path__ + "static/media/maestro.dae03f27.webp";